import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";

import "./InThePressHeroBanner.css";

const InThePressHeroBanner = () => {
    const data = useStaticQuery(graphql`
        query ITPHeroBannerQuery {
            mobileImage: file(
                relativePath: { eq: "itp-hb-hero-mobile-uc.png" }
            ) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }

            desktopImage: file(
                relativePath: { eq: "itp-hb-hero-desktop.png" }
            ) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }
        }
    `);

    const sources = [
        data.desktopImage.childImageSharp.fluid,
        {
            ...data.mobileImage.childImageSharp.fluid,
            media: `(max-width: 600px)`,
        },
    ];
    return (
        <div className="itp-hb">
            <div className="itp-hb__container">
                <Img
                    fluid={sources}
                    alt="PhonePe in the Press"
                    imgStyle={{
                        height: "100%",
                        width: "100%",
                        objectFit: "cover",
                    }}
                />

                <div className="itp-hb__container__header">
                    <div className="itp-hb-container">
                        <h2>In the Press</h2>
                        <p>
                            Read what the press has to say <br />
                            about us.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InThePressHeroBanner;
